import React from 'react';

import WpTextTruncate from '../WpTextTruncate';

const TextTruncateDocs = () => {
  const longText =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
  return (
    <>
      <h5>Without Tooltip</h5>
      <div style={{ width: '400px' }}>
        <WpTextTruncate text={longText} numberOfLines={2} />
      </div>
      <br />
      <br />
      <h5>With Tooltip</h5>
      <div style={{ width: '400px' }}>
        <WpTextTruncate text={longText} numberOfLines={2} showTooltip />
      </div>
    </>
  );
};

export default TextTruncateDocs;
